module.exports = __webpack_public_path__ + "img/rbooh.e9c7ee82.jpg";